import { render, staticRenderFns } from "./fillUpCard.vue?vue&type=template&id=58c24a49&"
import script from "./fillUpCard.vue?vue&type=script&lang=js&"
export * from "./fillUpCard.vue?vue&type=script&lang=js&"
import style0 from "./fillUpCard.vue?vue&type=style&index=0&id=58c24a49&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports